export enum RetentionType {
  Addiction = `Addiction`,
  FirstTime = `First time retention`,
  Recurring = `Recurring retention`,
  Frequency = `Frequency`, // We decided to move from using Addiction to Frequency
  Retention = `Retention`, // We consolidated retention types to just one type
}

export enum DeprecatedChartType {
  SegmentedBar = `bar-segmented`, // deprecated; DO NOT USE
}

export enum DateRangeType {
  Between = `between`,
  On = `on`,
  Relative = `in the last`,
  Since = `since`,
}

export enum CardAnalysisType {
  Cumulative = `cumulative`,
  Linear = `linear`,
  Logarithmic = `logarithmic`,
  Rolling = `rolling`,
}

export enum QueryType {
  Total = `total`,
  Unique = `unique`,
}
